import React from "react";

function LegacyCancelSubscription() {
  return (
    <div>
      You can deactivate your account
      <a href="mailto:hello@myhubly.com?subject=Please Deactivate my Hubly Account">
        &nbsp;here.
      </a>
    </div>
  );
}

export default LegacyCancelSubscription;
